import React, { useEffect } from "react";

import {
    Avatar,
    Badge,
    List,
    ListItem,
    makeStyles,
    Typography,
    IconButton,
    Theme,
    Grid,
} from "@material-ui/core";

import { useNotification } from "../../viewmodel/hooks/getNotification";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useProfile } from "../../viewmodel/hooks/getProfile";
import { getUserInfo } from "../../viewmodel/providers/userInfo";

import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";

import routes from "../../utils/routes.json";
import { UserContext } from "../../viewmodel/providers/user-context";
import api from "../../utils/api";
import apiRoutes from "../../utils/apiRoutes.json";

export interface StyleProps {
    color: string;
}

const useStyles = makeStyles<Theme, StyleProps>(() => ({
    badge: {
        backgroundColor: ({ color }) => color,
        borderRadius: "50%",
        color: "#fff",
        fontSize: "80%",
    },
    avatar: {
        fontSize: "200%",
        width: "50px",
        height: "50px",
    },
    centerVertically: {
        margin: "auto 0",
    },
    marginCard: {
        marginLeft: "15px",
        marginBottom: "-10px",
        marginTop: "-10px",
    },
    userInfo: {
        marginBottom: "-10px",
    },
    timeNotification: {
        color: "grey",
    },
    icon: {
        marginLeft: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    },
    item: {
        display: "flex",
        flexDirection: "row",
        border: "1px solid rgba(0,0,0,0.12)",
        borderRadius: "4px",
        marginBottom: "5px",
        backgroundColor: "white",
        "&:hover": {
            backgroundColor: "#f7f7f7",
        },
    },
}));

function getTime(time: number): string {
    let expression = "Invalid time";
    if (time > 1)
        expression = "notification-panel.plural-time";
    else if (time === 1)
        expression = "notification-panel.singular-time";
    return expression;
}

function getColor(type: string): string {
    let color;
    if (type === "VS")
        color = "#FF5A00";
    else
        color = "#00FF00";

    return color;
}

type GameProps = {
    notification: any,
}

export default function DropNotification({ notification }: GameProps): JSX.Element {
    const { t } = useTranslation();
    const [userState, setUser] = useProfile();
    const messageContent = JSON.parse(notification.message);
    const [{ category: message, type: notificationType, time }] = useNotification(notification.type, "vs", 0);
    const expression = getTime(2);
    const color = getColor("VS");
    const props = {
        color: color,
    };
    const classes = useStyles(props);

    useEffect(() => {
        getUserInfo(notification.body, setUser);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const avatar = userState.user.image === "" ? (
        <Avatar className={classes.avatar}>
            ?
        </Avatar>
    ) : (
        <Avatar
            alt={userState.user.name}
            src={userState.user.image}
            className={classes.avatar}
        />
    );

    const shownNotification = React.useContext(UserContext).shownNotification;
    const pathname = notification.type == "REMATCH" ? routes.replay : (notification.type == "NEW_FRIEND" ? routes.friendsList : routes.matchfriends)

    function addFriend(id: number) {
        if (notification.type == "NEW_FRIEND")
            api.post(apiRoutes.addFriend, { "friend_id": id });
    }

    return (
        <div style={{ position: "relative", left: "-50%" }}>
            <ListItem className={classes.item}>
                <Badge
                    badgeContent={notificationType}
                    overlap="circle"
                    anchorOrigin={{ vertical: "top", horizontal: "left" }}
                    classes={{ badge: classes.badge }}
                    className={classes.centerVertically}
                >
                    {avatar}
                </Badge>
                <List className={classes.marginCard}>
                    <Typography variant="h4" className={classes.userInfo}>
                        {userState.user.username}
                    </Typography>
                    <Typography variant="h6" className={classes.userInfo}>
                        {message}
                    </Typography>
                    <Typography variant="h6" className={classes.timeNotification}>
                        {t(expression, { time: time })}
                    </Typography>
                </List>
                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    style={{ flex: "1" }}
                >
                    <Link
                        to={{
                            pathname: pathname,
                            state: {
                                oponnentId: notification.body,
                                confirm: true,
                                categoryIds: messageContent.categoryIds.split(","),
                            },
                        }}
                        onClick={() => addFriend(notification.body)}

                        className={classes.icon}
                    >
                        <IconButton>
                            <CheckIcon style={{ color: "green" }} onClick={() => shownNotification(notification)} />
                        </IconButton>
                    </Link>

                    <IconButton className={classes.icon}>
                        <CloseIcon style={{ color: "crimson" }} onClick={() => shownNotification(notification)} />
                    </IconButton>
                </Grid>
            </ListItem>
        </div>
    );
}
